// extracted by mini-css-extract-plugin
export default {"subnavPanelWrapper":"SubnavPanel_subnavPanelWrapper__TmxjL","bookmarksList":"SubnavPanel_bookmarksList__T6bQG"};